import React from "react";
import { RouteObject } from "react-router-dom";
import { ServicePage } from "./ui";

export const serviceRoute: RouteObject = {
  path: "/service",
  element: <ServicePage />,
};
